import React from "react";
import { Accordion } from "@my-scoot/component-library-legacy";
import { AccordianLabel } from "./modules/AccordianLabel/AccordianLabel";

export const CustomColumnAccordian = ({
  children,
  onExpand,
  open,
  label,
  checked,
}) => {
  return (
    <div className="w-100">
      <Accordion
        expanded={open}
        onChange={onExpand}
        accordionSummaryContent={
          <AccordianLabel label={label} checked={checked} />
        }
        expandIconPosition="end"
      >
        {children}
      </Accordion>
    </div>
  );
};
